import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', size = 'md', className = '', onClick, ...props }) => {
  const baseStyles = "inline-flex items-center justify-center font-extrabold rounded-full transition-all border-2 border-ink-navy focus:outline-none focus:ring-4 focus:ring-sky-blue/30";
  
  const variants = {
    primary: "bg-lemon-yellow text-ink-navy hover:bg-lemon-bright shadow-[4px_4px_0_0_#1e1b4b]",
    secondary: "bg-sky-blue text-white hover:bg-sky-400 shadow-[4px_4px_0_0_#1e1b4b]",
    outline: "bg-white text-ink-navy hover:bg-slate-50 shadow-[2px_2px_0_0_#1e1b4b]",
    ghost: "bg-transparent border-transparent text-ink-navy hover:bg-slate-100",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  return (
    <motion.button
      whileHover={{ y: -2, x: -2, boxShadow: variant === 'ghost' ? 'none' : "6px 6px 0px 0px #1e1b4b" }}
      whileTap={{ y: 2, x: 2, boxShadow: "0px 0px 0px 0px #1e1b4b" }}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;